function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#microphone_filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 42,
  r: 18,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 42,
  r: 17.5,
  stroke: "currentColor",
  strokeOpacity: 0.6
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#microphone_clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.7419 46.0664H48.2555C50.7334 46.0664 52.7494 44.0504 52.7494 41.5725V35.5806C52.7494 33.0791 50.7334 31.0439 48.2555 31.0439H47.7419C45.2667 31.0439 43.2525 33.0747 43.248 35.5724V41.5725C43.248 44.0504 45.264 46.0664 47.7419 46.0664ZM47.7419 32.3279H48.2555C49.8968 32.3279 51.2535 33.5829 51.4422 35.1954H50.3955C50.0409 35.1954 49.7535 35.4829 49.7535 35.8374C49.7535 36.192 50.0409 36.4794 50.3955 36.4794H51.4654V37.9346H49.7107C49.3561 37.9346 49.0687 38.222 49.0687 38.5766C49.0687 38.9311 49.3561 39.2185 49.7107 39.2185H51.4654V40.6737H50.3955C50.0409 40.6737 49.7535 40.9611 49.7535 41.3157C49.7535 41.6702 50.0409 41.9577 50.3955 41.9577H51.4415C51.2505 43.5466 49.8951 44.7824 48.2555 44.7824H47.7419C46.1024 44.7824 44.747 43.5466 44.5559 41.9577H45.602C45.9565 41.9577 46.244 41.6702 46.244 41.3157C46.244 40.9611 45.9565 40.6737 45.602 40.6737H44.532V39.2185H46.2868C46.6413 39.2185 46.9288 38.9311 46.9288 38.5766C46.9288 38.222 46.6413 37.9346 46.2868 37.9346H44.532V36.4794H45.602C45.9565 36.4794 46.244 36.192 46.244 35.8374C46.244 35.4829 45.9565 35.1954 45.602 35.1954H44.5553C44.744 33.5829 46.1007 32.3279 47.7419 32.3279Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.4894 41.3158C55.4894 40.9613 55.2019 40.6738 54.8474 40.6738C54.4929 40.6738 54.2054 40.9613 54.2054 41.3158C54.2054 44.7377 51.4215 47.5217 47.9996 47.5217C44.5777 47.5217 41.7937 44.7377 41.7937 41.3158C41.7937 40.9613 41.5063 40.6738 41.1517 40.6738C40.7972 40.6738 40.5098 40.9613 40.5098 41.3158C40.5098 45.2294 43.5271 48.4511 47.3576 48.7778V51.6731H43.8909C43.5363 51.6731 43.2489 51.9606 43.2489 52.3151C43.2489 52.6697 43.5363 52.9571 43.8909 52.9571H52.1083C52.4628 52.9571 52.7503 52.6697 52.7503 52.3151C52.7503 51.9606 52.4628 51.6731 52.1083 51.6731H48.6416V48.7778C52.472 48.4511 55.4894 45.2294 55.4894 41.3158Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "microphone_filter0_d",
  x: 0,
  y: 0,
  width: 96,
  height: 96,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.258824 0 0 0 0 0.564706 0 0 0 0 0.952941 0 0 0 0.54 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "microphone_clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.913,
  height: 21.913,
  fill: "white",
  transform: "translate(37.043 31.0439)"
})));

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.347cdbb0.svg";
export { ForwardRef as ReactComponent };